import { useMutation, useQueryClient } from 'react-query';

import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useSetKimThreadNotifications = (matterId?: string, subsetId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ threadId, enableNotifications }: { threadId: string; enableNotifications: boolean }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        data: { enableNotifications },
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}/notifications`,
        fetchConfig,
      );
      if (!response.ok) {
        throw new Error('Updating Kim thread notifications failed');
      }

      trackCustomEvent(
        enableNotifications ? TrackingEventsV2.KimEnableNotifications : TrackingEventsV2.KimDisableNotifications,
        { matterId, subsetId, threadId },
      );
    },
    {
      onSuccess: (_data, { threadId }) => {
        queryClient.invalidateQueries([QueryEntity.KimThread, { threadId }]);
      },
    },
  );
};
